export const CALLICON = (
  <svg
    width="24"
    height="23"
    viewBox="0 0 24 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.9334 18.1928C17.8494 18.4494 17.706 18.6944 17.5008 18.9113C17.2956 19.1283 17.0595 19.3192 16.7781 19.4796C16.3028 19.7502 15.8269 19.9021 15.3337 19.9379C14.8477 19.976 14.3541 19.917 13.8552 19.7536C13.1281 19.5155 12.4073 19.09 11.702 18.4724C10.9967 17.8547 10.331 17.1159 9.71222 16.2582C9.08862 15.3911 8.52878 14.4738 8.02793 13.4969C7.53653 12.5152 7.12808 11.5213 6.80258 10.515C6.48421 9.51105 6.27987 8.54446 6.2015 7.62701C6.12546 6.70243 6.20881 5.86951 6.45156 5.12825C6.61028 4.64357 6.84752 4.20829 7.15863 3.83665C7.47207 3.45789 7.87362 3.14744 8.36809 2.91477C8.9713 2.61512 9.54258 2.55755 10.07 2.73027C10.2696 2.79562 10.4552 2.90374 10.6053 3.04762C10.7627 3.19384 10.8846 3.37582 10.9522 3.60315L11.8425 6.47537C11.9125 6.69557 11.9514 6.88985 11.9642 7.06766C11.9794 7.23835 11.966 7.3997 11.9217 7.53512C11.8656 7.70618 11.7597 7.8609 11.6063 7.99216C11.4599 8.12575 11.2685 8.25246 11.0414 8.36751L10.3153 8.75319C10.2112 8.80592 10.1452 8.88691 10.1079 9.00095C10.0892 9.05797 10.08 9.1102 10.0756 9.17189C10.0783 9.23591 10.0857 9.28568 10.0859 9.33311C10.1372 9.61033 10.2578 9.98918 10.45 10.4625C10.6494 10.9382 10.8678 11.428 11.1148 11.9271C11.3759 12.4309 11.6322 12.9015 11.9049 13.346C12.1729 13.781 12.4093 14.0951 12.6096 14.3028C12.6406 14.3287 12.6764 14.3641 12.7193 14.4018C12.7693 14.4419 12.824 14.4677 12.8881 14.4887C13.0093 14.5284 13.116 14.516 13.22 14.4632L13.9368 14.1061C14.1733 13.9862 14.3887 13.9068 14.5807 13.875C14.7773 13.8289 14.9576 13.8327 15.1357 13.891C15.2712 13.9354 15.4044 14.0105 15.5402 14.126C15.676 14.2415 15.8096 14.3879 15.9481 14.5674L17.7588 17.015C17.9021 17.2039 17.9814 17.3956 18.0014 17.5995C18.0144 17.801 17.9988 17.9932 17.9334 18.1928Z"
      stroke="#EDEDED"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M17.6377 10.7329C17.7777 10.3052 17.6575 9.53978 17.3336 8.84182C17.0385 8.20064 16.5587 7.61736 15.96 7.4213"
      stroke="#EDEDED"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.1323 11.5498C21.0356 8.79142 19.5352 5.82992 16.7769 4.92664"
      stroke="#EDEDED"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const NO1 = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2001_1898)">
      <path
        d="M20 0.46875C9.2132 0.46875 0.46875 9.2132 0.46875 20C0.46875 30.7868 9.2132 39.5312 20 39.5312C30.7868 39.5312 39.5312 30.7868 39.5312 20C39.5312 9.2132 30.7868 0.46875 20 0.46875ZM24.0684 29.7413H18.8198V14.6737H15.9316V10.2587H24.0684V29.7413Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_2001_1898">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const NO2 = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2025_5317)">
      <path
        d="M20 0.46875C9.2132 0.46875 0.46875 9.2132 0.46875 20C0.46875 30.7868 9.2132 39.5312 20 39.5312C30.7868 39.5312 39.5312 30.7868 39.5312 20C39.5312 9.2132 30.7868 0.46875 20 0.46875ZM27.2452 29.9899H12.7548V28.804C20.5937 19.5584 21.6734 18.0642 21.6734 16.3916C21.6734 15.3352 20.9774 14.6267 19.9795 14.6267C18.8858 14.6267 18.219 15.3644 18.219 16.5372V16.9141H13.0688V16.5537C13.0688 12.6144 15.6509 10.0105 19.9166 10.0105C24.0494 10.0105 26.9027 12.5514 26.9027 16.2091C26.9027 18.6608 25.9957 20.5428 21.8287 25.3696H27.2452V29.9899Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_2025_5317">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const NO3 = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2025_5319)">
      <path
        d="M20 0.46875C9.2132 0.46875 0.46875 9.2132 0.46875 20C0.46875 30.7868 9.2132 39.5312 20 39.5312C30.7868 39.5312 39.5312 30.7868 39.5312 20C39.5312 9.2132 30.7868 0.46875 20 0.46875ZM19.9184 29.967C15.7316 29.967 12.8534 27.2341 12.7363 23.2013H17.737C17.7955 24.5748 18.6496 25.4874 19.9308 25.4874C21.2625 25.4874 22.1964 24.5071 22.1964 23.0833C22.1964 21.6595 21.2286 20.7758 19.7124 20.7758H16.5917V19.6898L19.7642 14.474H13.2252V10.033H26.5937V10.9281L22.6834 17.188C25.4767 17.8888 27.2638 20.15 27.2638 23.1673C27.2638 27.1295 24.1931 29.967 19.9184 29.967Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_2025_5319">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const LINE = (
  <svg
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.0625 32.2578C24.899 32.2578 32.0625 25.0944 32.0625 16.2578C32.0625 7.42127 24.899 0.257812 16.0625 0.257812C7.22596 0.257812 0.0625 7.42127 0.0625 16.2578C0.0625 25.0944 7.22596 32.2578 16.0625 32.2578ZM16.0597 6.95772C21.3349 6.95772 25.6394 10.2634 25.8779 14.4123C25.8942 14.6666 25.8974 14.9216 25.8874 15.1763C25.8735 15.3759 25.8476 15.5745 25.8098 15.771C25.6864 16.5272 25.4321 17.2562 25.0582 17.925C24.8823 18.2425 24.0203 19.4506 23.7559 19.7688C22.3029 21.5193 19.8694 23.5397 15.8001 25.5034C15.714 25.5452 15.6182 25.5631 15.5227 25.5553C15.4273 25.5476 15.3357 25.5144 15.2574 25.4592C15.1792 25.404 15.1171 25.3289 15.0778 25.2416C15.0384 25.1543 15.0231 25.058 15.0336 24.9629L15.2386 23.1173C15.2465 23.0473 15.2404 22.9765 15.2208 22.9089C15.2012 22.8413 15.1685 22.7782 15.1244 22.7233C15.0804 22.6684 15.0259 22.6228 14.9641 22.589C14.9024 22.5552 14.8346 22.534 14.7646 22.5265C9.94797 22.0224 6.23054 18.7446 6.23054 14.7758C6.23084 10.4579 10.6314 6.95772 16.0597 6.95772Z"
      fill="white"
    />
    <path
      d="M10.0922 17.0113H12.1033C12.2366 17.0113 12.3645 16.9583 12.4588 16.8641C12.553 16.7698 12.606 16.6419 12.606 16.5086C12.606 16.3753 12.553 16.2474 12.4588 16.1531C12.3645 16.0589 12.2366 16.0059 12.1033 16.0059H10.5948V12.7127C10.5948 12.5793 10.5418 12.4515 10.4475 12.3572C10.3532 12.2629 10.2254 12.21 10.0921 12.21C9.95873 12.21 9.83087 12.2629 9.73659 12.3572C9.64232 12.4515 9.58936 12.5793 9.58936 12.7127V16.5085C9.58936 16.6418 9.64233 16.7697 9.73664 16.864C9.83094 16.9583 9.95884 17.0113 10.0922 17.0113Z"
      fill="white"
    />
    <path
      d="M15.3459 17.0122C15.4793 17.0122 15.6072 16.9592 15.7015 16.8649C15.7958 16.7706 15.8488 16.6427 15.8488 16.5093V14.2044C15.8488 14.2044 17.8872 16.8463 17.9176 16.8748C18.0094 16.9622 18.131 17.0113 18.2577 17.0121C18.394 17.0086 18.5234 16.9518 18.6183 16.8539C18.7132 16.7561 18.7659 16.6249 18.7652 16.4886V12.7135C18.7636 12.5812 18.7099 12.4548 18.6157 12.3619C18.5216 12.2689 18.3946 12.2167 18.2623 12.2167C18.13 12.2167 18.003 12.2689 17.9088 12.3619C17.8147 12.4548 17.761 12.5812 17.7594 12.7135V15.0324C17.7594 15.0324 15.7515 12.4135 15.7209 12.3791C15.6717 12.3237 15.6108 12.2799 15.5426 12.2509C15.4744 12.2219 15.4006 12.2084 15.3265 12.2113C15.1942 12.2198 15.0703 12.2788 14.9803 12.3761C14.8904 12.4734 14.8413 12.6017 14.8433 12.7342V16.5093C14.8433 16.6426 14.8962 16.7705 14.9905 16.8648C15.0848 16.9591 15.2126 17.0121 15.3459 17.0122Z"
      fill="white"
    />
    <path
      d="M13.4768 17.0114H13.6967C13.7483 17.0114 13.7994 17.0012 13.847 16.9815C13.8947 16.9617 13.938 16.9327 13.9745 16.8962C14.011 16.8597 14.0399 16.8164 14.0596 16.7687C14.0793 16.721 14.0895 16.6699 14.0895 16.6183V12.6028C14.0895 12.4986 14.0481 12.3987 13.9744 12.3251C13.9008 12.2514 13.8009 12.21 13.6967 12.21H13.4768C13.3727 12.21 13.2727 12.2514 13.1991 12.325C13.1254 12.3987 13.084 12.4986 13.084 12.6028V16.6183C13.084 16.6699 13.0941 16.721 13.1138 16.7687C13.1336 16.8164 13.1625 16.8597 13.199 16.8962C13.2355 16.9327 13.2788 16.9617 13.3265 16.9815C13.3741 17.0012 13.4252 17.0114 13.4768 17.0114Z"
      fill="white"
    />
    <path
      d="M20.0216 17.0121H22.0328C22.1662 17.0121 22.294 16.9592 22.3883 16.8649C22.4826 16.7706 22.5355 16.6428 22.5355 16.5094C22.5355 16.3761 22.4826 16.2482 22.3883 16.154C22.294 16.0597 22.1662 16.0067 22.0328 16.0067H20.5244V15.1142H22.0327C22.165 15.1126 22.2913 15.0589 22.3843 14.9648C22.4773 14.8707 22.5295 14.7437 22.5295 14.6113C22.5295 14.479 22.4773 14.352 22.3843 14.2579C22.2913 14.1638 22.165 14.1101 22.0327 14.1085H20.5244V13.216H22.0327C22.166 13.216 22.2938 13.1631 22.388 13.0688C22.4823 12.9746 22.5352 12.8468 22.5352 12.7135C22.5352 12.5802 22.4823 12.4524 22.388 12.3581C22.2938 12.2639 22.166 12.2109 22.0327 12.2109H20.0216C19.8883 12.211 19.7605 12.2639 19.6663 12.3582C19.572 12.4524 19.5191 12.5802 19.519 12.7135V16.5093C19.519 16.5753 19.532 16.6407 19.5573 16.7017C19.5825 16.7627 19.6195 16.8181 19.6662 16.8648C19.7128 16.9115 19.7682 16.9485 19.8292 16.9738C19.8902 16.9991 19.9556 17.0121 20.0216 17.0121Z"
      fill="white"
    />
  </svg>
);

export const FACEBOOK = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2029_6396)">
      <path
        d="M32 16C32 7.1625 24.8375 0 16 0C7.1625 0 0 7.1625 0 16C0 24.8375 7.1625 32 16 32C16.0938 32 16.1875 32 16.2812 31.9937V19.5438H12.8438V15.5375H16.2812V12.5875C16.2812 9.16875 18.3688 7.30625 21.4188 7.30625C22.8813 7.30625 24.1375 7.4125 24.5 7.4625V11.0375H22.4C20.7437 11.0375 20.4188 11.825 20.4188 12.9812V15.5312H24.3875L23.8687 19.5375H20.4188V31.3813C27.1063 29.4625 32 23.3063 32 16Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_2029_6396">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const IG = (
  <svg
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2029_6388)">
      <path
        d="M19.5947 16C19.5947 17.6914 18.2236 19.0625 16.5322 19.0625C14.8408 19.0625 13.4697 17.6914 13.4697 16C13.4697 14.3086 14.8408 12.9375 16.5322 12.9375C18.2236 12.9375 19.5947 14.3086 19.5947 16Z"
        fill="white"
      />
      <path
        d="M23.6943 10.5813C23.5471 10.1824 23.3123 9.82129 23.0071 9.5249C22.7107 9.21973 22.3499 8.98486 21.9507 8.83765C21.627 8.71191 21.1406 8.56226 20.2449 8.52148C19.2759 8.47729 18.9854 8.46777 16.5322 8.46777C14.0789 8.46777 13.7883 8.47705 12.8196 8.52124C11.9238 8.56226 11.4373 8.71191 11.1138 8.83765C10.7146 8.98486 10.3535 9.21973 10.0574 9.5249C9.7522 9.82129 9.51733 10.1821 9.36987 10.5813C9.24414 10.905 9.09448 11.3916 9.05371 12.2874C9.00952 13.2561 9 13.5466 9 16C9 18.4531 9.00952 18.7437 9.05371 19.7126C9.09448 20.6084 9.24414 21.0947 9.36987 21.4185C9.51733 21.8176 9.75195 22.1785 10.0571 22.4749C10.3535 22.78 10.7144 23.0149 11.1135 23.1621C11.4373 23.2881 11.9238 23.4377 12.8196 23.4785C13.7883 23.5227 14.0786 23.532 16.532 23.532C18.9856 23.532 19.2761 23.5227 20.2446 23.4785C21.1404 23.4377 21.627 23.2881 21.9507 23.1621C22.752 22.853 23.3853 22.2197 23.6943 21.4185C23.8201 21.0947 23.9697 20.6084 24.0107 19.7126C24.0549 18.7437 24.0642 18.4531 24.0642 16C24.0642 13.5466 24.0549 13.2561 24.0107 12.2874C23.97 11.3916 23.8203 10.905 23.6943 10.5813ZM16.5322 20.7175C13.9265 20.7175 11.8142 18.6055 11.8142 15.9998C11.8142 13.394 13.9265 11.282 16.5322 11.282C19.1377 11.282 21.25 13.394 21.25 15.9998C21.25 18.6055 19.1377 20.7175 16.5322 20.7175ZM21.4365 12.198C20.8276 12.198 20.334 11.7043 20.334 11.0955C20.334 10.4866 20.8276 9.99292 21.4365 9.99292C22.0454 9.99292 22.5391 10.4866 22.5391 11.0955C22.5388 11.7043 22.0454 12.198 21.4365 12.198Z"
        fill="white"
      />
      <path
        d="M16.5322 0C7.69702 0 0.532227 7.16479 0.532227 16C0.532227 24.8352 7.69702 32 16.5322 32C25.3674 32 32.5322 24.8352 32.5322 16C32.5322 7.16479 25.3674 0 16.5322 0ZM25.6643 19.7878C25.6199 20.7659 25.4644 21.4336 25.2373 22.0181C24.76 23.2522 23.7844 24.2278 22.5503 24.7051C21.9661 24.9321 21.2981 25.0874 20.3203 25.1321C19.3406 25.1768 19.0276 25.1875 16.5325 25.1875C14.0371 25.1875 13.7244 25.1768 12.7444 25.1321C11.7666 25.0874 11.0986 24.9321 10.5144 24.7051C9.90112 24.4744 9.34595 24.1128 8.88696 23.6453C8.41968 23.1865 8.05811 22.6311 7.82739 22.0181C7.60034 21.4338 7.44482 20.7659 7.40039 19.7881C7.35522 18.8081 7.34473 18.4951 7.34473 16C7.34473 13.5049 7.35522 13.1919 7.40015 12.2122C7.44458 11.2341 7.59985 10.5664 7.8269 9.98193C8.05762 9.3689 8.41943 8.81348 8.88696 8.35474C9.3457 7.88721 9.90112 7.52563 10.5142 7.29492C11.0986 7.06787 11.7664 6.9126 12.7444 6.86792C13.7241 6.82324 14.0371 6.8125 16.5322 6.8125C19.0273 6.8125 19.3403 6.82324 20.3201 6.86816C21.2981 6.9126 21.9658 7.06787 22.5503 7.29468C23.1633 7.52539 23.7188 7.88721 24.1777 8.35474C24.645 8.81372 25.0068 9.3689 25.2373 9.98193C25.4646 10.5664 25.6199 11.2341 25.6646 12.2122C25.7092 13.1919 25.7197 13.5049 25.7197 16C25.7197 18.4951 25.7092 18.8081 25.6643 19.7878Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_2029_6388">
        <rect
          width="32"
          height="32"
          fill="white"
          transform="translate(0.532227)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const MAIL = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2029_6392)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0ZM26.1562 22.2026V10.3111L20.2102 16.2568L26.1562 22.2026ZM7.114 22.4448H24.8864L19.4546 17.0131L17.3844 19.0829C17.2841 19.183 17.1481 19.2392 17.0063 19.2392H14.9938C14.9236 19.2393 14.8541 19.2255 14.7892 19.1987C14.7243 19.1719 14.6653 19.1325 14.6156 19.0829L12.5455 17.0131L7.11375 22.4448H7.114ZM5.84375 10.3108V22.2029L11.7898 16.2568L5.84375 10.3108ZM25.4004 9.55519H6.6L15.2153 18.1704H16.7851L25.4004 9.55519Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_2029_6392">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const PHONE = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2029_6394)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0ZM25.3937 23.4023C25.6224 23.1724 25.7507 22.8615 25.7507 22.5373C25.7507 22.2132 25.6224 21.9022 25.3937 21.6724L22.2618 18.5411C22.0319 18.3124 21.7208 18.184 21.3965 18.184C21.0722 18.184 20.7611 18.3124 20.5312 18.5411L19.6801 19.3926C19.3975 19.6776 19.0304 19.8637 18.6335 19.9231C18.2365 19.9826 17.831 19.9122 17.4773 19.7225C15.2625 18.5494 13.4511 16.7382 12.2778 14.5236C12.088 14.1698 12.0176 13.7642 12.0769 13.3671C12.1363 12.9701 12.3222 12.6028 12.6071 12.32L13.4598 11.4688C13.6884 11.2389 13.8168 10.9278 13.8168 10.6036C13.8168 10.2794 13.6884 9.96833 13.4598 9.73844L10.3279 6.6075C10.098 6.37874 9.78685 6.25031 9.46253 6.25031C9.13821 6.25031 8.82708 6.37874 8.59719 6.6075C8.46775 6.73656 8.304 6.8925 8.12887 7.0575C7.69094 7.47144 7.14456 7.98663 6.92369 8.3105C5.76037 10.0129 6.31825 12.2906 6.98844 13.9017C7.87375 16.0253 9.50537 18.3392 11.5844 20.4168C13.6616 22.4942 15.9748 24.126 18.0996 25.0113C19.7103 25.6824 21.9871 26.2389 23.6894 25.0759C24.0131 24.8548 24.5291 24.3098 24.9422 23.8713C25.1079 23.6964 25.2639 23.5313 25.3937 23.4023Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_2029_6394">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const BELL = (
  <svg
    // className="lg:w-[47px] lg:h-[47px] w-[] h-[32px]"
    width="47"
    height="47"
    viewBox="0 0 47 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.0644 38.1416C26.5045 41.324 23.4426 43.4696 20.2602 42.9097C18.6787 42.6314 17.3283 41.7177 16.47 40.493C15.6118 39.2682 15.2139 37.687 15.4922 36.1055"
      fill="white"
    />
    <path
      d="M27.0644 38.1416C26.5045 41.324 23.4426 43.4696 20.2602 42.9097C18.6787 42.6314 17.3283 41.7177 16.47 40.493C15.6118 39.2682 15.2139 37.687 15.4922 36.1055"
      stroke="#0FB2FB"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M26.7605 5.97606C20.3765 4.85279 14.2754 9.12814 13.1521 15.5122L12.1714 21.0861C11.9644 22.2626 11.1473 23.9681 10.3729 24.8658L7.50676 28.1594C5.73694 30.1943 6.23745 32.8872 8.59545 34.177C16.4195 38.417 25.388 39.995 34.1894 38.6803C36.6589 38.3194 38.1663 35.7412 37.2667 33.3957L35.6969 29.3216C35.2947 28.2168 35.1088 26.3349 35.3159 25.1584L36.2966 19.5844C37.4165 13.2197 33.1252 7.09593 26.7605 5.97606Z"
      fill="white"
      stroke="#002445"
      strokeWidth="2.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M27.1618 6.2673C26.5548 6.09105 25.9281 5.95397 25.2818 5.87564C23.4018 5.64064 21.6002 5.77772 19.916 6.2673C20.4839 4.81814 21.8939 3.7998 23.5389 3.7998C25.1839 3.7998 26.5939 4.81814 27.1618 6.2673Z"
      stroke="#002445"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const KEYS_TOP = (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.1784 15.9464V9.65172C17.1784 5.47999 13.7966 2.09814 9.62486 2.09814C5.45314 2.09814 2.07129 5.47999 2.07129 9.65172V15.9464"
      stroke="#0FB2FB"
      strokeWidth="2.51786"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const KEYS_BOTTOM = (
  <svg
    width="29"
    height="23"
    viewBox="0 0 29 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.99805 5.84954C1.99805 3.76368 3.68897 2.07275 5.77483 2.07275H23.3998C25.4857 2.07275 27.1766 3.76368 27.1766 5.84954V17.1799C27.1766 19.2658 25.4857 20.9567 23.3998 20.9567H5.77483C3.68897 20.9567 1.99805 19.2658 1.99805 17.1799V5.84954Z"
      stroke="#002445"
      strokeWidth="2.51786"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SHIELD = (
  <svg
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_330_3736"
      // style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="33"
      height="33"
    >
      <path d="M0 0.000125885H32.6V32.6001H0L0 0.000125885Z" fill="white" />
    </mask>
    <g mask="url(#mask0_330_3736)">
      <path
        d="M16.3 1.27356L3.82031 6.45498L3.82031 12.7537C3.82031 20.9052 8.7529 28.2462 16.3 31.3267C23.847 28.2462 28.7797 20.9052 28.7797 12.7537V6.45498L16.3 1.27356Z"
        fill="white"
        stroke="#0FB2FB"
        strokeWidth="2.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.334 15.2883L14.8929 18.8472L21.2668 12.4733"
        stroke="#0FB2FB"
        strokeWidth="2.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const CLOUD = (
  <svg
    width="60"
    height="37"
    viewBox="0 0 60 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M50.5509 16.3305C50.5528 16.2388 50.5544 16.147 50.5544 16.0547C50.5544 8.29226 44.2714 1.99961 36.5209 1.99961C31 1.99961 26.2247 5.19294 23.9335 9.83547C22.4745 8.61626 20.5974 7.88194 18.5486 7.88194C13.9423 7.88194 10.2028 11.5908 10.14 16.1891C5.52102 16.9611 2 20.9819 2 25.8271C2 31.2242 6.36875 35.5996 11.7576 35.5996H48.2425C53.6315 35.5996 58 31.2243 58 25.8272C58 21.2267 54.8256 17.3692 50.5509 16.3305Z"
      fill="white"
      stroke="#002445"
      strokeWidth="2.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EYES = (
  <svg
    className="lg:w-[24px] lg:h-[25px] w-[20px] h-[21px]"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.58 12.5C15.58 14.48 13.98 16.08 12 16.08C10.02 16.08 8.42004 14.48 8.42004 12.5C8.42004 10.52 10.02 8.92 12 8.92C13.98 8.92 15.58 10.52 15.58 12.5Z"
      stroke="#EDEDED"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.9998 20.7697C15.5298 20.7697 18.8198 18.6897 21.1098 15.0897C22.0098 13.6797 22.0098 11.3097 21.1098 9.89973C18.8198 6.29973 15.5298 4.21973 11.9998 4.21973C8.46984 4.21973 5.17984 6.29973 2.88984 9.89973C1.98984 11.3097 1.98984 13.6797 2.88984 15.0897C5.17984 18.6897 8.46984 20.7697 11.9998 20.7697Z"
      stroke="#EDEDED"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const COPYLINK = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.631 20.0029C14.6598 20.0173 14.703 20.0173 14.703 20.0173V20.0461C14.7462 20.0461 14.8324 19.9885 14.8324 19.9885L16.3868 18.4341C16.4018 18.4192 16.4166 18.4053 16.431 18.3919C16.4723 18.3533 16.5094 18.3185 16.5308 18.2759C16.5595 18.2183 16.5739 18.1607 16.5452 18.1031C16.5164 18.0456 16.4732 17.988 16.4156 17.988C15.8255 17.8584 15.293 17.5705 14.8612 17.1388C14.3575 16.6495 14.0552 16.0017 13.9832 15.2677C13.897 14.3611 14.2136 13.4687 14.8612 12.821L18.9343 8.74795C20.0858 7.59655 22.1007 7.59655 23.252 8.74795C23.8278 9.33805 24.1444 10.1008 24.1444 10.9212C24.1444 11.7416 23.8278 12.5188 23.252 13.0945L21.3955 14.9368C21.3523 14.9799 21.3379 15.0519 21.3523 15.1095C21.525 15.7284 21.6258 16.376 21.6258 17.0237C21.6258 17.3403 21.6114 17.6137 21.5682 17.844C21.5682 17.916 21.597 18.0024 21.669 18.0312C21.7408 18.0743 21.8272 18.0599 21.8848 18.0024L25.0367 14.8648C27.21 12.6771 27.21 9.13655 25.0367 6.96329C22.8635 4.79001 19.323 4.79001 17.1496 6.96329L13.0766 11.0364C12.7168 11.3962 12.4289 11.7848 12.213 12.1734C12.2082 12.1782 12.2018 12.183 12.1954 12.1878C12.1826 12.1974 12.1699 12.207 12.1699 12.2166C11.2775 13.8141 11.2055 15.7428 11.9971 17.3835C12.2706 17.9448 12.616 18.4485 13.0766 18.9091C13.5227 19.3696 14.0552 19.7439 14.631 20.0029ZM6.97412 25.0389C8.06796 26.1184 9.49281 26.6653 10.9177 26.6653L10.8745 26.6797C12.2994 26.6797 13.7386 26.1328 14.818 25.0533L18.8911 20.9803C19.6395 20.2319 20.1576 19.3108 20.3879 18.2889L20.4743 17.6556C20.5031 17.5117 20.5031 17.3677 20.5031 17.2239V17.1663V17.0367V16.6481C20.5031 16.5041 20.4887 16.3603 20.4599 16.2451C20.4455 16.0868 20.4167 15.9573 20.3879 15.8277C20.3592 15.6839 20.316 15.5255 20.2584 15.3528C20.0138 14.5324 19.5532 13.7552 18.9055 13.1076C18.4738 12.6758 17.9412 12.3016 17.3655 12.0281C17.3079 11.9849 17.164 12.0569 17.164 12.0569L15.6096 13.6113C15.5664 13.6545 15.5088 13.712 15.4658 13.7984C15.437 13.8416 15.437 13.8992 15.4658 13.9567C15.4944 14.0143 15.5376 14.0575 15.5952 14.0575C16.1854 14.1727 16.7179 14.4604 17.1496 14.8923C17.7254 15.4823 18.042 16.2595 18.0276 17.1087C18.0132 17.6268 17.8836 18.1305 17.639 18.5623C17.5814 18.6631 17.5095 18.7783 17.3943 18.9077C17.3367 18.9941 17.2648 19.0948 17.1496 19.21L13.0766 23.2831C12.5009 23.8444 11.7237 24.1611 10.9177 24.1611C10.1117 24.1611 9.32011 23.8444 8.7588 23.2831C8.18309 22.6929 7.86645 21.9301 7.86645 21.1099C7.86645 20.2895 8.18309 19.5123 8.7588 18.9365L10.6154 17.0799C10.6586 17.0223 10.673 16.9504 10.6586 16.8928C10.3708 16.0004 10.2844 15.0937 10.4139 14.1869C10.4283 14.1151 10.3851 14.0287 10.3132 13.9999C10.2556 13.9567 10.1117 14.0287 10.1117 14.0287L6.97412 17.1519C5.90908 18.2025 5.33337 19.6129 5.33337 21.0955C5.33337 22.5779 5.92347 23.9883 6.97412 25.0389Z"
      fill="black"
    />
  </svg>
);

export const FACEBOOK_CIRCLE = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32 16C32 7.1625 24.8375 0 16 0C7.1625 0 0 7.1625 0 16C0 24.8375 7.1625 32 16 32C16.0938 32 16.1875 32 16.2812 31.9937V19.5438H12.8438V15.5375H16.2812V12.5875C16.2812 9.16875 18.3688 7.30625 21.4188 7.30625C22.8813 7.30625 24.1375 7.4125 24.5 7.4625V11.0375H22.4C20.7437 11.0375 20.4188 11.825 20.4188 12.9812V15.5312H24.3875L23.8687 19.5375H20.4188V31.3813C27.1063 29.4625 32 23.3062 32 16Z"
      fill="#007CB3"
    />
  </svg>
);

export const LINE_CIRCLE = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_330_4390)">
      <path
        d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
        fill="#39CD00"
      />
      <path
        d="M26 15.6364C25.9858 15.8395 25.9597 16.0417 25.9218 16.2418C25.7953 17.008 25.5363 17.7464 25.1564 18.4236C24.9745 18.7473 24.1 19.9764 23.8327 20.3C22.3545 22.08 19.8782 24.1346 15.74 26.1327C15.6527 26.1749 15.5557 26.1931 15.4591 26.1853C15.3624 26.1775 15.2696 26.1441 15.1902 26.0886C15.1107 26.033 15.0475 25.9573 15.007 25.8692C14.9666 25.7811 14.9503 25.6838 14.96 25.5873L15.1691 23.7091C15.1849 23.5654 15.1431 23.4213 15.0527 23.3085C14.9624 23.1956 14.8309 23.1233 14.6873 23.1073C13.3106 22.9696 11.9696 22.5872 10.7273 21.9782C7.89091 20.5764 6 18.0727 6 15.22C6 10.8273 10.4764 7.27274 16 7.27274C18.7745 7.27274 21.2836 8.18183 23.0909 9.62364C24.7836 10.9782 25.8673 12.8164 25.9836 14.8564C26.003 15.1159 26.0085 15.3763 26 15.6364Z"
        fill="white"
      />
      <path
        d="M13.2436 16.98C13.292 17.0273 13.3303 17.0839 13.3562 17.1464C13.3822 17.2089 13.3952 17.276 13.3945 17.3436C13.3948 17.4109 13.3817 17.4775 13.3562 17.5397C13.3306 17.6019 13.293 17.6584 13.2455 17.7061C13.1981 17.7537 13.1417 17.7915 13.0796 17.8173C13.0175 17.8431 12.9509 17.8564 12.8836 17.8564H10.8382C10.7023 17.8559 10.5722 17.8017 10.4762 17.7057C10.3801 17.6096 10.3259 17.4795 10.3255 17.3436V13.48C10.325 13.4124 10.3381 13.3453 10.364 13.2829C10.39 13.2204 10.4282 13.1638 10.4764 13.1164C10.5479 13.0446 10.6392 12.9957 10.7386 12.9759C10.8381 12.9562 10.9411 12.9665 11.0347 13.0055C11.1283 13.0444 11.2081 13.1104 11.2641 13.1949C11.3201 13.2794 11.3497 13.3786 11.3491 13.48V16.8309H12.8836C12.9506 16.8304 13.0169 16.8433 13.0788 16.8689C13.1406 16.8945 13.1967 16.9323 13.2436 16.98Z"
        fill="#00C200"
      />
      <path
        d="M14.9091 13.3691V17.4545C14.9086 17.5605 14.8663 17.6619 14.7914 17.7368C14.7165 17.8118 14.615 17.854 14.5091 17.8545H14.28C14.1739 17.8545 14.0722 17.8124 13.9972 17.7374C13.9221 17.6624 13.88 17.5606 13.88 17.4545V13.3691C13.88 13.263 13.9221 13.1612 13.9972 13.0862C14.0722 13.0112 14.1739 12.9691 14.28 12.9691H14.5036C14.5566 12.9686 14.6091 12.9786 14.6581 12.9984C14.7072 13.0183 14.7518 13.0477 14.7895 13.0848C14.8272 13.122 14.8571 13.1662 14.8776 13.215C14.8982 13.2638 14.9089 13.3161 14.9091 13.3691Z"
        fill="#00C200"
      />
      <path
        d="M19.6582 13.48V17.3218C19.6583 17.46 19.6047 17.5928 19.5087 17.6922C19.4126 17.7916 19.2818 17.8498 19.1437 17.8545C19.0142 17.8525 18.8903 17.8019 18.7964 17.7127C18.7782 17.6982 18.0909 16.8036 17.5073 16.0509C17.0709 15.4891 16.6927 14.9982 16.6927 14.9982V17.3418C16.6931 17.4412 16.6645 17.5384 16.6104 17.6218C16.5563 17.7051 16.4791 17.7708 16.3882 17.811C16.2974 17.8511 16.1968 17.8639 16.0988 17.8477C16.0007 17.8315 15.9096 17.7872 15.8364 17.72C15.7836 17.6722 15.7414 17.6138 15.7126 17.5487C15.6838 17.4835 15.669 17.4131 15.6691 17.3418V13.5018C15.6674 13.3668 15.7176 13.2363 15.8093 13.1372C15.9009 13.0381 16.0271 12.9779 16.1618 12.9691C16.2381 12.9678 16.3137 12.9835 16.3831 13.0149C16.4526 13.0464 16.5143 13.0928 16.5637 13.1509C16.5855 13.1764 17.6418 14.5509 18.2364 15.3327C18.4727 15.6382 18.6364 15.8527 18.6364 15.8527V13.4891C18.6373 13.3539 18.6915 13.2245 18.7871 13.1289C18.8827 13.0333 19.0121 12.9791 19.1473 12.9782C19.2812 12.9782 19.4098 13.0307 19.5054 13.1246C19.6009 13.2185 19.6558 13.3461 19.6582 13.48Z"
        fill="#00C200"
      />
      <path
        d="M21.4545 15.9218V16.8309H22.9872C23.057 16.8267 23.1269 16.8369 23.1926 16.8607C23.2583 16.8846 23.3185 16.9216 23.3694 16.9695C23.4202 17.0175 23.4608 17.0753 23.4885 17.1395C23.5162 17.2036 23.5305 17.2728 23.5305 17.3427C23.5305 17.4126 23.5162 17.4818 23.4885 17.546C23.4608 17.6101 23.4202 17.668 23.3694 17.7159C23.3185 17.7638 23.2583 17.8009 23.1926 17.8247C23.1269 17.8485 23.057 17.8587 22.9872 17.8545H20.9363C20.8007 17.8541 20.6707 17.7998 20.5749 17.7037C20.4792 17.6076 20.4254 17.4775 20.4254 17.3418V13.48C20.4259 13.3446 20.4799 13.215 20.5756 13.1193C20.6713 13.0235 20.801 12.9696 20.9363 12.9691H22.9818C23.0516 12.9649 23.1215 12.9751 23.1872 12.9989C23.2529 13.0228 23.313 13.0598 23.3639 13.1077C23.4148 13.1556 23.4553 13.2135 23.483 13.2777C23.5107 13.3418 23.525 13.411 23.525 13.4809C23.525 13.5508 23.5107 13.62 23.483 13.6841C23.4553 13.7483 23.4148 13.8061 23.3639 13.8541C23.313 13.902 23.2529 13.939 23.1872 13.9629C23.1215 13.9867 23.0516 13.9969 22.9818 13.9927H21.4545V14.9018H22.9872C23.1227 14.9018 23.2527 14.9556 23.3485 15.0514C23.4443 15.1473 23.4981 15.2772 23.4981 15.4127C23.4981 15.5482 23.4443 15.6782 23.3485 15.774C23.2527 15.8698 23.1227 15.9236 22.9872 15.9236L21.4545 15.9218Z"
        fill="#00C200"
      />
    </g>
    <defs>
      <clipPath id="clip0_330_4390">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const TWITTER_CIRCLE = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_330_4433)">
      <path
        d="M16 0C7.16375 0 0 7.16375 0 16C0 24.8363 7.16375 32 16 32C24.8363 32 32 24.8363 32 16C32 7.16375 24.8363 0 16 0Z"
        fill="black"
      />
      <path
        d="M17.7504 14.552L24.5998 6.59018H22.9767L17.0293 13.5034L12.2792 6.59018H6.80054L13.9836 17.0441L6.80054 25.3934H8.42372L14.7043 18.0928L19.7207 25.3934H25.1994L17.75 14.552H17.7504ZM9.00856 7.8121H11.5017L22.9774 24.2271H20.4843L9.00856 7.8121Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_330_4433">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const HAMBURGER_MENU = (
  <svg
    width="24"
    height="17"
    viewBox="0 0 24 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="3" fill="white" />
    <rect y="7" width="10" height="3" fill="white" />
    <rect x="14" y="7" width="10" height="3" fill="white" />
    <rect y="14" width="24" height="3" fill="white" />
  </svg>
);

export const CALL_MB = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2054_2236)">
      <mask
        id="mask0_2054_2236"
        // style="mask-type:luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path d="M0 0H24V24H0V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_2054_2236)">
        <path
          d="M4.18124 2.66251L9.35624 3.18751V8.36251L6.76874 10.425C7.83749 13.2375 9.78749 15.6375 12.3375 17.2875L15.0562 15.225L19.9687 16.2563C19.9687 16.3313 19.4437 21.4313 19.4437 21.4313C9.73124 20.9438 2.62499 12.2813 4.18124 2.66251ZM2.54999 0.543762L2.26874 2.28751C1.40624 7.38751 2.79374 12.6188 6.05624 16.65C9.35624 20.7 14.2125 23.1375 19.425 23.3813L21.2062 23.475L21.3937 21.6938C21.9187 16.4625 21.9187 16.4063 21.9187 16.2938V14.7563L20.4187 14.4375L15.4687 13.3875L14.625 13.2L13.9312 13.725L12.3 14.9625C10.95 13.875 9.84374 12.525 9.03749 10.9688L10.5 9.78751L11.2125 9.22501V1.40626L9.50624 1.23751L4.31249 0.712512L2.54999 0.543762Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2054_2236">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CLOSE = (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M29.7499 29.7499L4.25 4.25"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29.7501 4.25L4.25 29.7501"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LIGHT_CIRCLE = (
  <svg
    width="624"
    height="624"
    viewBox="0 0 624 624"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_f_136_4638)">
      <path
        d="M0 192C0 85.9613 85.9613 0 192 0C298.039 0 384 85.9613 384 192C384 298.039 298.039 384 192 384C85.9613 384 0 298.039 0 192Z"
        fill="#155DFC"
        fillOpacity="0.2"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_136_4638"
        x="-240"
        y="-240"
        width="864"
        height="864"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="120"
          result="effect1_foregroundBlur_136_4638"
        />
      </filter>
    </defs>
  </svg>
);

export const SENT_SVG = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_136_4668)">
      <path
        d="M9.6907 14.4577C9.71603 14.5208 9.76006 14.5747 9.81688 14.6121C9.87371 14.6494 9.9406 14.6685 10.0086 14.6668C10.0766 14.665 10.1424 14.6426 10.1973 14.6023C10.2521 14.5621 10.2933 14.506 10.3154 14.4417L14.6487 1.77503C14.67 1.71596 14.6741 1.65203 14.6604 1.59073C14.6468 1.52943 14.6159 1.47329 14.5715 1.42888C14.5271 1.38447 14.471 1.35363 14.4097 1.33996C14.3484 1.32629 14.2844 1.33036 14.2254 1.3517L1.5587 5.68503C1.49436 5.70709 1.43832 5.74831 1.39808 5.80314C1.35785 5.85798 1.33535 5.92381 1.33361 5.9918C1.33186 6.05979 1.35096 6.12669 1.38834 6.18351C1.42571 6.24034 1.47958 6.28437 1.5427 6.3097L6.82937 8.4297C6.99649 8.49661 7.14833 8.59667 7.27574 8.72385C7.40315 8.85103 7.50349 9.00269 7.5707 9.1697L9.6907 14.4577Z"
        stroke="white"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5692 1.43164L7.27588 8.72431"
        stroke="white"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_136_4668">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const MAP_BLUE = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 10C20 14.993 14.461 20.193 12.601 21.799C12.4277 21.9293 12.2168 21.9998 12 21.9998C11.7832 21.9998 11.5723 21.9293 11.399 21.799C9.539 20.193 4 14.993 4 10C4 7.87827 4.84285 5.84344 6.34315 4.34315C7.84344 2.84285 9.87827 2 12 2C14.1217 2 16.1566 2.84285 17.6569 4.34315C19.1571 5.84344 20 7.87827 20 10Z"
      stroke="#51A2FF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z"
      stroke="#51A2FF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CALL_PURPLE = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.832 16.568C14.0385 16.6628 14.2712 16.6845 14.4917 16.6294C14.7122 16.5744 14.9073 16.4458 15.045 16.265L15.4 15.8C15.5863 15.5516 15.8279 15.35 16.1056 15.2111C16.3833 15.0723 16.6895 15 17 15H20C20.5304 15 21.0391 15.2107 21.4142 15.5858C21.7893 15.9609 22 16.4696 22 17V20C22 20.5304 21.7893 21.0391 21.4142 21.4142C21.0391 21.7893 20.5304 22 20 22C15.2261 22 10.6477 20.1036 7.27208 16.7279C3.89642 13.3523 2 8.7739 2 4C2 3.46957 2.21071 2.96086 2.58579 2.58579C2.96086 2.21071 3.46957 2 4 2H7C7.53043 2 8.03914 2.21071 8.41421 2.58579C8.78929 2.96086 9 3.46957 9 4V7C9 7.31049 8.92771 7.61672 8.78885 7.89443C8.65 8.17214 8.44839 8.41371 8.2 8.6L7.732 8.951C7.54842 9.09118 7.41902 9.29059 7.36579 9.51535C7.31256 9.74012 7.33878 9.97638 7.44 10.184C8.80668 12.9599 11.0544 15.2048 13.832 16.568Z"
      stroke="#C27AFF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MAIL_BLUE = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 7L13.009 12.727C12.7039 12.9042 12.3573 12.9976 12.0045 12.9976C11.6517 12.9976 11.3051 12.9042 11 12.727L2 7"
      stroke="#51A2FF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 4H4C2.89543 4 2 4.89543 2 6V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V6C22 4.89543 21.1046 4 20 4Z"
      stroke="#51A2FF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
